import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const checkNotifications = async () => {
  const url = `${backendUrl}/api/notifications/check-notifications/`;
  
  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при проверке уведомлений');
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при отправке GET запроса на /check-notifications/:', error);
    throw error;
  }
};